import { createStore } from 'zustand/vanilla';
import { ModelType } from 'types';

export type DataCardState = {
  selectedModel: ModelType | null;
};

export type DataCardActions = {
  setSelectedModel: (model: ModelType | null) => void;
};

export type DataCardStore = DataCardState & DataCardActions;

export const createDataCardStore = (
  initialState: Partial<DataCardState> = {},
) => {
  return createStore<DataCardStore>()((set) => ({
    selectedModel: null,
    ...initialState,

    setSelectedModel: (selectedModel) => set({ selectedModel }),
  }));
};
